// import { Component, OnInit } from '@angular/core';
import { FirstTimeUserOnboardingComponent } from '../../../digigov/dg_core/first-time-user-onboarding/first-time-user-onboarding.component';
import { map, take, tap } from 'rxjs/operators';
import { AppInitService } from 'src/app/digigov/services/app-init.service';
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  TemplateRef,
  HostListener,
  // ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Option } from '../../models/theme-option.model';
import options from '../../../../assets/my-theme/dg-theme-list.json';
import { StyleManagerService } from '../../services/theme-manager.service';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/digigov/services/authentication.service';
import { HttpClient, HttpParams } from '@angular/common/http';

//import { UserProfileComponent } from '../../../digigov/dg_core/user-profile/user-profile.component';
import { SettingsComponent } from '../../../digigov/dg_core/settings/settings.component';
import { LogoutComponent } from '../../../digigov/dg_core/logout/logout.component';

import { ChangePasswordComponent } from '../../../digigov/dg_core/change-password/change-password.component';
import { LoaderService } from '../../services/loader.service';
import { SwitchPostComponent } from '../../../digigov/dg_core/switch-post/switch-post.component';
import { SwitchPostService } from '../../../digigov/dg_core/switch-post/switch-post.service';
import { Observable, Subject, Subscription } from 'rxjs';
import { DataPrivacyPolicyComponent } from '../../../digigov/dg_core/data-privacy-policy/data-privacy-policy.component';
import { HeaderService } from '../../../digigov/dg_core/header/service/header.service';
import { FormControl } from '@angular/forms';
import { UserProfileComponent } from '../user-profile/user-profile.component';
import { MatMenu } from '@angular/material/menu';
import { SessionCheckerService } from '../../services/session-checker.service';
import { Response } from '../../models/response.model';
import { BuildPopupComponent } from 'src/app/cfms/ems/build-popup/build-popup.component';
import { VerifyPopupComponent } from 'src/app/cfms/ems/verify-popup/verify-popup.component';
import { CreateCaseService } from '../create_case/create-case.service';
import envjson from 'src/assets/config/env.json';
export interface User {
  EMP_ID: string | number;
  FIRSTLOGIN: boolean;
  IS_SEC_QUE_SET: boolean;
  LANG_ID: string | number;
  LOCALE: string | number;
  LOC_ID: string | number;
  LOGIN_ID: number;
  SECURE_REQUEST: boolean;
  ServerPort: number;
  TOKEN_ID: string;
  lastLogin?: string;
  passwordExpireDate?: string;
  crtPost?: unknown;
  employeeVO: {
    allUnitVO: any[];
    empId: number;
    empFirstName: string;
    empMiddleName?: string;
    empLastName: string;
    dsgnName?: string;
    crtPost?: unknown;
    uniqueId?: string;
    [key: string]: unknown;
  };
  isPasswordChangeAllowed?: boolean;
  isPasswordExpired?: boolean;
  isResetPasswordAllowed?: boolean;
  pswdAlertDayCnt?: number;
  groupIds?: Number[];
  [key: string]: unknown;
}

@Component({
  selector: 'dg-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  isMobileView = false;

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.checkIfMobileView();
  }

  private checkIfMobileView(): void {
    this.isMobileView = window.innerWidth <= 768; // Adjust the breakpoint as needed
  }

  broadCastChannel : BroadcastChannel = new BroadcastChannel("AUTHENTICATION");
  count: any = '12k';
  search = new FormControl('');
  headerLogoId;
  options: Array<Option> = options;
  selectedTheme: Option;

  showSpinner = false;
  isOpened = true;
  jsonData={"email":"","mobile":""};
  timedOutCloser;
  isHeaderLogo;
  currentUser: string;
  showUserButton: boolean = true;
  lang: string;
  now: Date;
  lastLogin: string;
  pwdExpiry: string;
  empDsgnName: string;
  @Output() public sidenavToggle = new EventEmitter();
  empId = 3000446;
  currentPost = '';
  locale: any;
  content: User;
  empfName: string;
  emplName: string;
  empfullName: string;
  showNotify = false;
  profileAttachTitle = '';
  isProfileComponent = true; //flag to indetify profile Attachment Component
  profileAcceptedType = ['png', 'jpeg', 'jpg'];
  profileMaxSize = 5000000;
  profileUniqueAttachID = 'User Profile';
  isAllowFileToAttachProfile = false;
  profileAttachID = ''; //130573304
  empPhotoAttachId = null;
  isAllowDelete = false;

  isPasswordChangeAllowed = true;
  showPasswordExpireMessageBanner = false;
  pwdExpireDayCount = null;
  showSwitchPost: boolean = false;
  posts: any;
  selectedPost;
  defaultPost;
  isChangePass: boolean = false;
  popupList: any = [];
  execSubject = new Subject<number>();
  activeExecId: number = 0;
  @ViewChild('menu') menu: MatMenu;
  //session checker variables
  minutes: number = 0;
  seconds: number = 0;
  hideTimer: boolean = false;

  sessionStatus$: Observable<number> = this.sessionService?.sessionCheckerStatus$.pipe(
    tap((status) => {
      //open dialog if another tab is refreshed or api is called after clicking on close button
      if (
        this.hideTimer &&
        !this.dialog.getDialogById('session-alert') &&
        status === 1
      ) {
        this.hideTimer = false;
      }
    })
  );
  sessionRemainingTime$: Observable<number> = this.sessionService?.sessionRemainingTime$.pipe(
    tap((timeLeft: number) => {
      //logout if timeleft === 0
      if (timeLeft === 0) {
        this.authenticationService.logout(true);
      } else {
        this.minutes = Math.floor(timeLeft / 60);
        this.seconds = timeLeft - this.minutes * 60;
        //To close dialogBox if another tab is refreshed or api is called
        if (
          timeLeft >
            this.appInitService?.appConfig?.showSessionCheckerAt * 60 &&
          this.dialog.getDialogById('session-alert')
        ) {
          this.dialog.getDialogById('session-alert').close();
        }
        //prevent multiple dialog opening
        if (
          timeLeft != -1 &&
          timeLeft <
            this.appInitService?.appConfig?.showSessionCheckerAt * 60 &&
          !this.dialog.getDialogById('session-alert') &&
          !this.hideTimer
        ) {
          this.dialog.open(this.sessionAlert, {
            id: 'session-alert',
            disableClose: true,
          });
        }
      }
    })
  );
  @ViewChild('sessionAlert') sessionAlert: TemplateRef<any>;
  showEnvDetails: boolean;
  subscription: Subscription;
  singlePost = null;
  isDiscomEnabledTP = false;
  discomName: string;
  env: any;
  constructor(
    private router: Router,
    private dialog: MatDialog,
    private http: HttpClient,
    private readonly styleManager: StyleManagerService,
    public loaderService: LoaderService,
    public appInitService: AppInitService,
    public headerService: HeaderService,
    private authenticationService: AuthenticationService,
    private dialog2: MatDialog,
    public switchPostService: SwitchPostService,
    public sessionService: SessionCheckerService
  ) {
    this.currentUser = String(this.authenticationService.currentUserValue);
    this.locale = this.appInitService.locale;

    this.loaderService.isLoading.subscribe((value) => {
      this.isHeaderLogo = this.appInitService?.appConfig?.branding.mainLogo;
    });
    // this.env = envjson?.env;
    // this.subscription = this.sessionService.getMessage().subscribe((data) => {
    //   console.log('BroadCast data : ' + JSON.stringify(data));
    //   //this.userList.push(data);
    // });
  }

  ngOnInit(): void {
    this.checkIfMobileView();
    this._broadCastChannelPostMessage_();
    this.authenticationService.getUserDetails().subscribe((res) => {
      const restemp: any = res;
      const content = restemp;
      if(restemp)
      {
       this.jsonData.email=restemp.emailID;
       this.jsonData.mobile=restemp.mobile_no;
      }
     
      if (content?.empPhotoAttachId) {
        this.empPhotoAttachId = content?.empPhotoAttachId;
      }
      // this.appInitService?.getConfigurableFields()?.subscribe(() => {
      this.isDiscomEnabledTP = this.appInitService?.appConfig?.configurableFields?.isDiscomEnabledTP;
      if (this.isDiscomEnabledTP) {
        this.populateDisccom(content);
      }
      this.fetchLoginDetails();
      // this.checkVerificationPopup();
      // });
    });

   

   
this.checkSwichPost('login');


    
    if (
      localStorage.getItem('headerLogoId') &&
      localStorage.getItem('headerLogoId') != 'undefined'
    ) {
      this.headerLogoId = JSON.parse(localStorage.getItem('headerLogoId'));
    }
    this.showEnvDetails = this.appInitService?.appConfig?.showEnvDetails;
    this.getCount(this.empId);
    // this.authenticationService.getUserDetails().subscribe((res) => {
    //   if (res.empPhotoAttachId) {
    //     this.empPhotoAttachId = res.empPhotoAttachId;
    //   }
    // });
  }
  _broadCastChannelPostMessage_(){
    let origin = null;
    console.log("Data is")
    console.log(window.location.href)
    console.log(sessionStorage)
    console.log(localStorage)
    if(new URL(window.location.href).searchParams.has("origin")) {
      let origin = new URL(window.location.href).searchParams.get("origin");
      origin = origin;
    }else{
      origin = "DIGIGOV";
    }
    let url=sessionStorage.getItem("URL");
    if(origin == "DIGIGOV" ){
      if(url!=null && url!=undefined && url!="")
      {
        if(!url.includes("masterUI_2") && !url.includes("audit") && 
          !url.includes("ebilling-2") && !url.includes("budget-allotment-manual")  &&
          !url.includes("payee") &&
        !url.includes("AG")  && !url.includes("deposit") && !url.includes("snaclaim") )
        this.broadCastChannel.postMessage(
          {
            origin: origin,
            identifier:"DIGIGOV"
          }
        );
      }
      else
      {
        this.broadCastChannel.postMessage(
          {
            origin: origin,
            identifier:"DIGIGOV"
          }
        );
      }
    }
  }
  populateDisccom(profileData) {
    if (profileData?.orgId) {
      this.http
        .get('/admin/parent-organization-details', {
          params: {
            prntId: profileData?.orgId,
          },
        })
        .subscribe((res) => {
          const resTmp: any = res;
          const parentOrgData = resTmp.data;
          parentOrgData.forEach((element: any) => {
            if (element?.typeId === 12) {
              this.discomName = element?.name;
            }
          });
        });
    }
  }

  loadPost() {
    this.http.get(`/core/switch-post`).subscribe();
  }
  menuOpened() {
    if (this.allowSwitchPost()) {
      // this.checkSwichPost('button');
    }
  }
  hideCountDownTimer(): void {
    this.hideTimer = true;
  }
  continueSession(): void {
    this.http.get('/core/user-preferences').subscribe();
  }
  fetchLoginDetails(): void {
    let loggedInObs: Observable<User> = this.authenticationService.loggedInUserSubject.asObservable();
    if (!this.authenticationService.loggedInUser?.EMP_ID) {
      loggedInObs = this.http
        .get(`/admin/user-login-dtls`)
        .pipe(map((response: Response<User>) => response?.data));
    }

    loggedInObs.pipe(take(1)).subscribe(
      (res: User) => {
        this.authenticationService.loggedInUser = res;
        const restemp: User = res;
        this.content = restemp;
        this.empId = this.content?.employeeVO?.empId;
        this.empfName = this.content?.employeeVO?.empFirstName
          ? this.content?.employeeVO?.empFirstName
          : '';
        this.emplName = this.content?.employeeVO?.empLastName
          ? this.content?.employeeVO?.empLastName
          : '';
        this.empfullName = this.empfName + ' ' + this.emplName;

        this.empDsgnName = this.content?.employeeVO?.dsgnName;
        this.lastLogin = this.content?.lastLogin;
        this.pwdExpiry = this.content?.passwordExpireDate;

        this.isPasswordChangeAllowed = this.content?.isPasswordChangeAllowed;
        this.pwdExpireDayCount = this.content?.pswdAlertDayCnt;
        if (this.content?.employeeVO?.allUnitVO?.length == 1) {
          if (this.isDiscomEnabledTP) {
            this.singlePost =
              this.content?.employeeVO?.allUnitVO[0]?.unitName +
              ' , ' +
              this.discomName;
          } else {
            this.singlePost =
              this.content?.employeeVO?.allUnitVO[0]?.unitName +
              ' , ' +
              this.content?.employeeVO?.allUnitVO[0]?.organizationVOArr[0]
                ?.organizationName;
          }
        }
        if (this.authenticationService?.justLogin) {
          this.getPopupList();
        }
        if (
          !this.content?.isPasswordExpired &&
          this.content?.pswdAlertDayCnt > 0 &&
          this.appInitService?.appConfig?.showPwdExpireMsgBanner
        ) {
          this.showPasswordExpireMessageBanner = true;
        }
        // if (this.content?.isResetPasswordAllowed) {
        //   this.goToisResetPassword({
        //     message:
        //       'Your password has been Reset, please change it to continue.',
        //     hideCancelButton: true,
        //   });
        // }
      },
      (error) => {
        console.log('error', error);
        if (this.authenticationService?.justLogin) {
          this.getPopupList();
        }
      }
    );
  }
  goToisResetPassword(data = null) {
    this.dialog.open(ChangePasswordComponent, {
      width: '80vw',
      disableClose: true,
      data,
    });
  }
  getPopupList() {
    this.http.get('/admin/homepage-popups').subscribe((res) => {
      console.log(res);
      this.popupList = res['data'];
      this.execSubject.subscribe((res) => {
        console.log('data', res);
        if (res < this.popupList.length) {
          this.activeExecId = res;
          this.execPopupLists(res);
        } else {
          this.authenticationService.justLogin = false;
        }
      });
      this.execSubject.next(0);
    });
  }
  execPopupLists(ind) {
    switch (this.popupList[ind].className) {
      case 'FirstTimeUserOnboardingComponent':
        // this.openFirstTimeUserOnboardingDialog();
        break;
      // case 'ChangePasswordComponent':
      //   if (this.content?.isPasswordExpired) {
      //     this.goToChangePassword({
      //       message:
      //         'Your password has been expired, please change it to continue.',
      //       hideCancelButton: true,
      //       origin: 'login',
      //     });
      //   } else {
      //     this.execSubject.next(this.activeExecId + 1);
      //   }
      //   break;
      case 'SwitchPostComponent':
        if (this.allowSwitchPost()) {
          //this.checkSwichPost('login');
        } else {
          this.execSubject.next(this.activeExecId + 1);
        }
        break;
      default:
        console.log('default');
        this.execSubject.next(this.activeExecId + 1);
        break;
    }
  }
  allowSwitchPost() {
    if (
      !this.authenticationService?.loggedInUser?.FIRSTLOGIN &&
      !this.content?.isPasswordExpired
    ) {
      return true;
    } else {
      return false;
    }
  }
  checkSwichPost(origin) {
    this.switchPostService.getSwitchPostDtls().subscribe(
      (res) => {
        if (res?.allPost) {
          this.posts = res?.allPost;
          if (this.posts.length > 1) {
            this.showSwitchPost = true;
            this.fetchCurrentPost(res?.postDetailsVO, res?.defaultPostId);

            if (origin === 'login') {
              if (
                this.authenticationService?.justLogin //&&
                && localStorage.getItem("justLogin").toString()=="true"
                /*  this.activeExecId < this.popupList.length &&
                this.popupList[this.activeExecId].className ==
                  'SwitchPostComponent' */
              ) {
                  localStorage.setItem("verificationPopup","true")
                if (res?.dialogOpenFlag === 0) {
                  this.openSwitchPost(origin);
                } else {
                  this.execSubject.next(this.activeExecId + 1);
                }
              }
            }
          } else {
            if (this.switchPostService?.useGeoLocBasedPostSelection) {
              this.currentPost = this.posts[0]?.geoLocDtls;
            }
            if (origin === 'login') {
              this.execSubject?.next(this.activeExecId + 1);
            }
          }
        }
      },
      (error) => {
        console.log('error');
        this.execSubject?.next(this.activeExecId + 1);
      }
    );
  }
  getCount(empId: number): void {
    const inputJson = {
      extendedVO: null,
      customXidBean: null,
      dbSchema: null,
      inboxOrOutbox: 'Inbox',
      docType: '',
      langId: 1,
      locId: 1,
      empId: empId,
      folderId: -1,
      field: null,
      operation: null,
      value1: null,
      value2: null,
      docTypeIds: [9],
      stageIds: null,
      statusIds: null,
      newFlag: 1,
      urgentFlag: null,
      markedFlag: null,
      tourFlag: null,
      paginationVO: null,
      unitIdArr: null,
      numericFileNo: null,
      papsFlag: null,
      exportExcel: 0,
      intCatId: 0,
      subjectId: 0,
      paramFlag: null,
      srFlag: null,
      unitId: 0,
      forPostIds: null,
      gdptIds: null,
    };
    console.log(inputJson);
    this.headerService.getIntimationCount();
  }

  public onToggleSidenav = (): void => {
    this.sidenavToggle.emit();
  };
  goToUserProfile(): void {
    const dialogRef = this.dialog.open(UserProfileComponent, {
      width: '65%',
      disableClose: true,
    }); //for Open dialog
    //this.router.navigateByUrl('main/user-profile');
    dialogRef.afterClosed().subscribe((r) => {
      if (r) {
        this.fetchLoginDetails();
      }
    });
  }
  goToSettings(): void {
    console.log();
  }
  goToIntimations(): void {
    void this.router.navigateByUrl('main/notifications');
  }
  goToNewSettings(): void {
    this.dialog.open(SettingsComponent, {
      width: '1000px',
      maxHeight: '600px',
      disableClose: true,
    });
  }

  showNotificaitons() {
    this.showNotify = true;
  }
  goToHome(): void {
    void this.router.navigateByUrl('main');
  }

  showLoader(): void {
    if (!this.showSpinner) {
      this.showSpinner = true;
    }
  }
  hideLoader(): void {
    if (this.showSpinner) {
      this.showSpinner = false;
    }
  }

  logout(): void {
    // console.log("logout clicked");

    // this.authenticationService.logout();
    this.dialog.open(LogoutComponent, { disableClose: true });
  }

  /* start for user profile menu hover*/

  clickOnHover(): void {
    // this.clickMe._elementRef.nativeElement.click();
  }

  /* end for user profile menu hover*/

  openDrawer(): void {
    this.isOpened = !this.isOpened;
    this.sidenavToggle.emit();
  }

  goToChangePassword(data = null): void {
    let url=location.href.toString().split("/main")[0]
    window.open(url+"/myaccount",'_blank')
    // this.http.get('/security/change-password/check-prerequisite').subscribe(
    //   (res) => {
    //     console.log(res);
    //     const restemp = res['data'];
    //     if (restemp) {
    //       this.isChangePass = true;
    //       const dialog = this.dialog.open(ChangePasswordComponent, {
    //         width: '65vw',
    //         disableClose: true,
    //         data,
    //       });

    //       dialog.afterClosed().subscribe((res) => {
    //         if (data?.origin == 'login') {
    //           this.execSubject.next(this.activeExecId + 1);
    //         }
    //       });
    //     } else {
    //       this.isChangePass = false;
    //     }
    //   },
    //   (err) => {
    //     console.log('error', err);
    //     this.isChangePass = false;
    //   }
    // );
  }

  // openFirstTimeUserOnboardingDialog() {
  //   if (this.authenticationService?.loggedInUser?.FIRSTLOGIN) {
  //     const dialog = this.dialog.open(FirstTimeUserOnboardingComponent, {
  //       width: '90vw',
  //       disableClose: true,
  //       backdropClass: 'first-time-user-onboarding-backdrop',
  //     });
  //     dialog.afterClosed().subscribe((res) => {
  //       this.execSubject.next(this.activeExecId + 1);
  //     });
  //   } else {
  //     this.execSubject.next(this.activeExecId + 1);
  //   }
  // }
  openDataPrivacyPolicy() {
    if (this.authenticationService?.loggedInUser?.dataPrivacyPolicy) {
      const dialog = this.dialog.open(DataPrivacyPolicyComponent, {
        width: '90vw',
        disableClose: true,
        backdropClass: 'first-time-user-onboarding-backdrop',
      });
      dialog.afterClosed().subscribe((res) => {
        this.execSubject.next(this.activeExecId + 1);
      });
    } else {
      this.execSubject.next(this.activeExecId + 1);
    }
  }
  openSwitchPost(origin) {
    const dialog = this.dialog2.open(SwitchPostComponent, {
      width: '550px',
      disableClose: true,
      data: {
        origin: origin,
        posts: this.posts,
        defaultPost: this.defaultPost,
        selectedPost: this.selectedPost,
      },
    });
    dialog.afterClosed().subscribe((res) => {
      if (origin == 'login') {
        this.execSubject.next(this.activeExecId + 1);
      }
    });
  }
  fetchCurrentPost(postDetails, defaultPostId) {
    if (postDetails) {
      const restemp = postDetails;
      this.selectedPost = restemp;
      if (restemp == 'Default') {
        if (defaultPostId) {
          const restemp = defaultPostId;
          this.defaultPost = restemp;
          if (restemp == -1) {
            this.currentPost = 'All Posts';
          } else {
            this.posts.forEach((element, index) => {
              if (element.postId == restemp) {
                if (this.switchPostService?.useGeoLocBasedPostSelection) {
                  this.currentPost = this.posts[0]?.geoLocDtls;
                } else {
                  this.currentPost = element.postName + ', ' + element.orgName;
                }
              }
            });
          }
        }
      } else if (restemp == 'All Selected') {
        this.currentPost = 'All Posts';
      } else {
        this.posts.forEach((element, index) => {
          if (element.postId == restemp.POST_Id) {
            if (this.switchPostService?.useGeoLocBasedPostSelection) {
              this.currentPost = this.posts[0]?.geoLocDtls;
            } else {
              this.currentPost = element.postName + ', ' + element.orgName;
            }
          }
        });
      }
    }
  }
  onFinalPathForProfile(finalPath: Event): void {
    //Will provide the finalPath for first component
    console.log('finalPath>>>>', finalPath);
  }
  //dfghj
  isExpanded: boolean = false;

  expandSearchBox() {
    this.isExpanded = !this.isExpanded;
  }
  //jjm
  buildDetails()
  {
    const dialog=this.dialog2.open(BuildPopupComponent,
      {
        width:"800px"
      });

      

  }
  
  // contactDetails()
  // {
  //   const dialog=this.dialog2.open(VerifyPopupComponent,
  //     {
  //       width: '800px',
  //       data: this.jsonData

  //     });

      

  // }
  
  checkVerificationPopup()
  {
      if(localStorage.hasOwnProperty("verificationPopup"))
      {
          if(localStorage.getItem("verificationPopup").toString()=="true")
          {
             const dialog=this.dialog2.open(VerifyPopupComponent,
      {
        width: '800px',
        data: this.jsonData

      }); 
      
      dialog.afterClosed().subscribe((res) => {

       localStorage.removeItem("verificationPopup");
      });

          }
      }
  }

}

export class TooltipOverviewExample {}
function UserProfileCloneComponent(
  UserProfileCloneComponent: any,
  arg1: { disableClose: true }
) {
  throw new Error('Function not implemented.');
}

function ChangePasswordNewComponent(
  ChangePasswordNewComponent: any,
  arg1: { width: string; disableClose: true; data: any }
) {
  throw new Error('Function not implemented.');
}
